import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ColaboradoresService } from 'app/main/wizard-cgo/services/colaboradores.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';

@Component({
  selector: 'app-modal-filtros',
  templateUrl: './modal-filtros.component.html',
  styleUrls: ['./modal-filtros.component.scss']
})
export class ModalFiltrosComponent implements OnInit {
categorias: string[] = [];
categoriasSelecciona:any[]=[];
filtrosElegidos:string[]=[];
  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalFiltrosComponent>,
    private colaboradoresService: ColaboradoresService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
  ) {
    lang_focus.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    }); }

  ngOnInit() {
    console.log('datos',this.datos);
this.categorias=this.datos.demograficos;
  }


  salir() {
    if (this.filtrosElegidos.length>0) {
      this.dialogRef.close(this.filtrosElegidos);
    }else{
      this.dialogRef.close();        
    }
  }

  opcionesDemografico(key){
    console.log('filtro seleccionado',key);
    this.colaboradoresService.getFiltersDemograficosKey(key).subscribe( (opcionesFiltro: any) => {
        console.log('opciones por categoria',opcionesFiltro);
        this.categoriasSelecciona.push({key:key,opciones:opcionesFiltro.options})
      });

      console.log('categoriasSelecciona',this.categoriasSelecciona);

  }

}
